// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Costs_wrapper__Bt2wp","freeOrderMessage":"Costs_freeOrderMessage__Nuq_h"};